/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, styled } from "@mui/material";

export const DiscountCardNameContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  justifyContent: 'flex-start'
});

export const DiscountCardColorContainer = styled(Box)({
  width: "12px",
  height: "12px",
  borderRadius: "50%",
  border: '1px solid gray',
});

export const NameIconContainer = styled('div')({
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
})
